import React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import ButtonBooking from '../buttons/button_booking';
import { HotelUtility } from './hotel_title';

const HotelDescription = ({
  blok,
  hotel,
  season,
  destination,
  price,
  priceType,
}) => {
  const blockWidths = {
    '25%': 'w-1/2 col-span-12 md:col-span-3',
    '33%': 'w-1/2 col-span-12 md:col-span-6 lg:col-span-4',
    '50%': 'w-full col-span-12 md:col-span-6',
    '66%': 'w-full col-span-12 md:col-span-6 lg:col-span-8',
    '75%': 'w-full col-span-12 md:col-span-9',
    '100%': 'w-full col-span-12',
  };

  return (
    <div
      {...storyblokEditable(blok)}
      key={blok._uid}
      className={`py-2 px-4 md:px-8 ${blockWidths[blok.width]}`}
    >
      <div className="">
        <HotelUtility
          hotel={hotel}
          destination={destination}
          inHotelDescription={true}
        />
      </div>
      {hotel.descriptions && hotel.descriptions.length > 0 && (
        <div
          className={`h-fit hide-h2`}
          dangerouslySetInnerHTML={{ __html: hotel.descriptions[0].value }}
        ></div>
      )}
      <div className="-mx-5 py-4">
        <ButtonBooking
          hotel={{
            id: hotel.id,
            name: hotel.name,
            coming_soon: hotel.coming_soon,
          }}
          blok={{ label: 'Boka nu' }}
          season={season}
          destination={hotel.destinationId}
          price={price}
          priceType={priceType}
        />
      </div>
    </div>
  );
};

export default HotelDescription;
